import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import Radium from 'radium'
import { actionButtonClicked } from 'aria-viewer/analytics/analyticActions'
import { MAIN_ACTION_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

const S = {
    /**
     * Get theme for button with possible ADA compliance
     * TODO use JSS?
     */
    getActionTheme: actionid => {
        return {
            ...styleguide.buttons[actionid],
        }
    },
    getButtonStyle: (isRegistrationEnabled, actionid, welcomePrompt, style) => {
        return {
            ...S.getActionTheme(
                isRegistrationEnabled && actionid === 'action2' && !welcomePrompt ? 'action1' : actionid
            ),
            ...style,
        }
    },
    getLabelStyle: (actionid, labelStyle) => {
        return {
            ...S.getActionTheme(actionid).label,
            ...labelStyle,
        }
    },
}

class ActionButton extends PureComponent {
    handleClick = e => {
        const {
            onClick,
            action: { analyticsAction, actionid, name, color },
            actionButtonClicked,
        } = this.props

        actionButtonClicked({
            action: analyticsAction,
            color: color || S.getActionTheme(actionid).actionColor,
            name,
        })

        onClick && onClick(e)
    }

    render() {
        const {
            style,
            labelStyle,
            children,
            action: { url, actionid },
            className,
            isRegistrationEnabled,
            welcomePrompt = false,
        } = this.props

        /* Adding #yvexternal will force the mobile app to open in System browser. */
        const actionURL = url && this.props.client.isClientApp ? url + '#yvexternal' : url
        return (
            <a
                tabIndex={MAIN_ACTION_BUTTON_INDEX}
                className={className || ''}
                href={actionURL}
                id={`action_${actionid}`}
                target="_blank"
                onClick={this.handleClick}
                alt={children}
                style={S.getButtonStyle(isRegistrationEnabled, actionid, welcomePrompt, style)}
            >
                <span style={S.getLabelStyle(actionid, labelStyle)}>{children}</span>
            </a>
        )
    }
}

export default connect(
    mapSelectorsToProps(['client', 'isRegistrationEnabled']),
    {
        actionButtonClicked,
    }
)(Radium(ActionButton))
